import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Alert, Button, TextareaAutosize, Typography } from "@mui/material";
import { fontWeight } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function Decline({
  getAssignmentCourses,
  setalertRejectFailed,
  rejectalignwithdatabase,
}) {
  let api = useAxiosPrivate();

  let [reason, setReason] = useState("");
  let [alert, setAlert] = useState(false);

  let { coursetoReject, setCoursetoReject } = useContext(
    CourseAssignmentContext
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    disableScroll();
    return () => {
      enableScroll();
    };
  }, []);
  useEffect(() => {
    setCoursetoReject({ ...coursetoReject, reasonForDecline: reason });
  }, [reason]);

  useEffect(() => {
    setTimeout(() => {
      setAlert(false);
    }, 10000);
  }, [alert]);

  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function () {
          supportsPassive = true;
        },
      })
    );
  } catch (e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent =
    "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

  // call this to Disable
  function disableScroll() {
    window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
    window.addEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener("DOMMouseScroll", preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener("touchmove", preventDefault, wheelOpt);
    window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
  }

  let handleDecline = () => {
    if (reason !== "") {
      setCoursetoReject({ ...coursetoReject, reasonForDecline: reason });
      declineRequest();
    } else {
      setAlert(true);
    }
  };

  let declineRequest = async () => {
    let resp = await api.post(
      `courseallocation/declineRequestForStaff?batch=${coursetoReject.batch}&courseCode=${coursetoReject.courseCode}&requester=${coursetoReject.requester}&requestedTo=${coursetoReject.requestedTo}`,
      {
        reasonForDecline: coursetoReject.reasonForDecline,
      }
    );

    if (resp.data.msg == true) {
      setCoursetoReject({});
      rejectalignwithdatabase(coursetoReject.courseCode);
    } else if (resp.data.msg == false) {
      setCoursetoReject({});
      setalertRejectFailed(true);
      setTimeout(() => {
        setalertRejectFailed(false);
      }, 10000);
    } else {
      alert(resp.data.msg);
    }
  };

  return (
    <div className="declineFormWrapper">
      <div className="declineform">
        <h1
          style={{
            textAlign: "center",
          }}
        >
          Please let the department know why you would like to decline the
          request.
        </h1>

        {alert == true && (
          <Alert
            sx={{ fontSize: "18px", fontWeight: "500" }}
            severity="warning"
          >
            You have not provided a reason!
          </Alert>
        )}
        <FormControl>
          <RadioGroup name="radio-buttons-group">
            <FormControlLabel
              onChange={() => {
                setReason("Number of staff insufficient");
              }}
              value="Number of staff insufficient"
              control={
                <Radio
                  sx={{
                    marginLeft: 10,
                  }}
                />
              }
              label={<h3>Number of staff insufficient</h3>}
            />
            <FormControlLabel
              onChange={() => {
                setReason("Current request running over the time limit");
              }}
              value="Current request running over the time limit"
              control={
                <Radio
                  sx={{
                    marginLeft: 10,
                  }}
                />
              }
              label={<h3>Current request running over the time limit</h3>}
            />
          </RadioGroup>
        </FormControl>

        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          <TextareaAutosize
            onChange={(e) => {
              setReason(e.target.value);
            }}
            aria-label="minimum height"
            minRows={8}
            placeholder="Leave a message for the department,write your reason"
            value={reason}
            style={{
              width: 500,
              fontSize: "21px",
            }}
          />
        </div>

        <div className="decline-btn-div">
          {/*
                   <button className='decline-cancel-btn'
                    onClick={()=>{
                    setCoursetoReject({})
                }}>
                        Cancel
            </button>*/}
          <Button
            variant="outlined"
            sx={{ marginRight: "15px" }}
            onClick={() => {
              setCoursetoReject({});
            }}
          >
            Cancel
          </Button>

          {/*
                   <button className='decline-btn' onClick={handleDecline}>
                   Decline
              </button>
              */}
          <Button
            variant="contained"
            sx={{ marginRight: "15px" }}
            onClick={handleDecline}
          >
            Decline
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Decline;
